import { vm } from './instance' // vue实例
import { defineAsyncComponent } from 'vue'

const Map = defineAsyncComponent(() => import('@/components/Map/index.vue'))
vm.component('Map', Map)

const CommonBg = defineAsyncComponent(() => import('@/components/CommonBg/index.vue'))
vm.component('CommonBg', CommonBg)

const Line = defineAsyncComponent(() => import('@/components/Line/index.vue'))
vm.component('Line', Line)

const PicPreview = defineAsyncComponent(() => import('@/components/PicPreview/index.vue'))
vm.component('PicPreview', PicPreview)

const CommonInput = defineAsyncComponent(() => import('@/components/CommonInput/index.vue'))
vm.component('CommonInput', CommonInput)

const CommonSearch = defineAsyncComponent(() => import('@/components/CommonSearch/index.vue'))
vm.component('CommonSearch', CommonSearch)

const CommonTable = defineAsyncComponent(() => import('@/components/CommonTable/index.vue'))
vm.component('CommonTable', CommonTable)

const CommonModal = defineAsyncComponent(() => import('@/components/CommonModal/index.vue'))
vm.component('CommonModal', CommonModal)

const CameraControl = defineAsyncComponent(() => import('@/components/CameraControl/index.vue'))
vm.component('CameraControl', CameraControl)

const CommonPlayer = defineAsyncComponent(() => import('@/components/CommonPlayer/index.vue'))
vm.component('CommonPlayer', CommonPlayer)

const ResourceView = defineAsyncComponent(() => import('@/components/ResourceView/index.vue'))
vm.component('ResourceView', ResourceView)

const CommonTitle = defineAsyncComponent(() => import('@/components/CommonTitle/index.vue'))
vm.component('CommonTitle', CommonTitle)

const PicEnlarge = defineAsyncComponent(() =>
    import('@/components/ResourceView/components/PicEnlarge/index.vue')
)
vm.component('PicEnlarge', PicEnlarge)

const EmptyDefault = defineAsyncComponent(() => import('@/components/EmptyDefault/index.vue'))
vm.component('EmptyDefault', EmptyDefault)

const LocaleSwitch = defineAsyncComponent(() => import('@/components/CommonLocaleSwitch/index.vue'))
vm.component('LocaleSwitch', LocaleSwitch)
